<template>
  <div id="maatontwikkeling">
    <router-view />
  </div>
</template>

<style>
  @import "assets/stylesheets/base.css";
</style>
